import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useStyles } from '../styles/index.js';

const Image = forwardRef(({ alt, ...props }, ref) => {
    const styles = useStyles();
    return (jsx("img", { ...props, "data-testid": props['data-testid'] || 'image', alt: alt, className: clsx(styles.root, props.className), ref: ref }));
});
Image.displayName = 'Image';

export { Image };
